import {requestFetch, requestFetchOptions} from 'models/Autobatcher';
import {loadingCompleted, loadingFailed, loadingStarted} from 'models/LoadingStateReduxActions';
import {getStore} from 'redux-stores/Store';
import * as StorableActions from 'samples/StorableActions';
import StorableStore from 'samples/StorableStore';

const MODEL_TYPE = 'STORABLE_SUMMARY_EXTRAS';
export default class StorableSummaryExtrasManager {
  static requestFetch(id: string, {forceFetch}: requestFetchOptions = {forceFetch: false}): void {
    requestFetch(this, id, {forceFetch});
  }

  static async fetchMulti(storableIds: Array<string>): Promise<void> {
    try {
      getStore().dispatch(loadingStarted(MODEL_TYPE, storableIds));
      await StorableActions.bulkGetStorableSummaryExtras(storableIds);
      getStore().dispatch(loadingCompleted(MODEL_TYPE, storableIds));
    } catch (e) {
      getStore().dispatch(loadingFailed(MODEL_TYPE, storableIds));
      throw e;
    }
  }

  static isKeyLoadedOrLoading(storableId: string): boolean {
    return this.areKeysLoadedOrLoading([storableId]);
  }

  /**
   * @param storableIds
   * @returns true if storable summary extras are loaded or loading for each of `storableIds`
   */
  static areKeysLoadedOrLoading(storableIds: Array<string>): boolean {
    const loadingState = getStore().getState().models.loadingState[MODEL_TYPE];
    const ancestralStorablesById = StorableStore.getStorableSummaryExtras().ancestralStorablesById;
    return storableIds.every(
      (storableId) =>
        (loadingState && loadingState[storableId]) ||
        (ancestralStorablesById && ancestralStorablesById[storableId])
    );
  }

  // Some storable summaries may have made it into the redux store some other way, and storable summary
  // extras may not have been fetched for them. Check for presence in ancestralStorableIdsByStorableId
  // and queue up anything missing for bulk fetch.
  static requestFetchIfMissing(storableIds: Array<string>): void {
    const ancestralStorableIdsByStorableId =
      StorableStore.getStorableSummaryExtras().ancestralStorableIdsByStorableId || {};
    const storableIdsMissingSummaryExtras = storableIds.filter(
      (storableId) => !ancestralStorableIdsByStorableId.hasOwnProperty(storableId)
    );
    if (storableIdsMissingSummaryExtras.length > 0) {
      for (const storableId of storableIdsMissingSummaryExtras) {
        StorableSummaryExtrasManager.requestFetch(storableId);
      }
    }
  }
}
